/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions, FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON, } from './FxIdDomainSettingsAdvertisementGtagForDomainOptions';
export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions(json)) {
        return FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions(value)) {
        return FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementGtagOptionsDefault.js.map